import React from 'react';
import { Link } from 'react-router-dom';
import cl from './FinalCTA.module.css';
import { IconArrowRight, IconMail } from '../../components/icons';
import useReveal from '../../hooks/useReveal';

export default function FinalCTA() {
    const revealRef = useReveal();
    return (
        <section className={cl.cta} ref={revealRef}>
            <div className={cl.blob + ' ' + cl.blob1}/>
            <div className={cl.blob + ' ' + cl.blob2}/>

            <div className={cl.inner}>
                <span className={cl.eyebrow} data-reveal="pop">Готовы открыть IT-направление?</span>
                <h2 className={cl.title} data-reveal="up" style={{ '--reveal-delay': '120ms' }}>
                    Начните с <span className={cl.accent}>бесплатного демо</span><br/>
                    уже сегодня
                </h2>
                <p className={cl.subtitle} data-reveal="up" style={{ '--reveal-delay': '220ms' }}>
                    Регистрация занимает 2 минуты. Платить ничего не нужно —
                    получите 50 учеников и 5 курсов, чтобы спокойно всё посмотреть.
                </p>

                <div className={cl.actions} data-reveal-stagger>
                    <Link to="/registration" className={cl.btnPrimary} data-reveal="left">
                        Открыть демо <IconArrowRight width={18} height={18}/>
                    </Link>
                    <a href="mailto:maksimivankov26@yandex.ru" className={cl.btnGhost} data-reveal="right">
                        <IconMail width={18} height={18} style={{ marginRight: 8 }}/>
                        Написать на почту
                    </a>
                </div>

                <p className={cl.helper} data-reveal="up" style={{ '--reveal-delay': '450ms' }}>
                    Или напишите напрямую: <a href="mailto:maksimivankov26@yandex.ru">maksimivankov26@yandex.ru</a>
                    {' · '}отвечаем в течение рабочего дня
                </p>
            </div>
        </section>
    );
}
